import { Grid, Typography, Divider } from '@mui/material';

import { IEntityData, IEntityDetailsProps } from '../../../api/type-def';

import styles from './Overview.module.scss';

const Details = ({
	entityData,
	isPreviewPage = false,
}: IEntityDetailsProps) => {
	const excludeValues = [
		'Description',
		'number',
		'name',
		'productName',
		'controlOwnerId',
		'Tags',
	];
	const renderDetailRows = ({ label, value }: IEntityData) => (
		<div key={label}>
			<Grid container className={styles['row-container-style']}>
				<Grid item xs={isPreviewPage ? 3 : 4}>
					<Typography
						className={
							styles[
								isPreviewPage ? 'preview-detail-text' : 'control-detail-label'
							]
						}
					>
						{label.charAt(0).toUpperCase() + label.slice(1)}
					</Typography>
				</Grid>
				<Grid item xs={isPreviewPage ? 9 : 8}>
					<Typography
						className={
							styles[
								isPreviewPage ? 'preview-detail-text' : 'control-detail-value'
							]
						}
					>
						{value &&
						label === 'products' &&
						typeof value === 'object' &&
						value?.length > 0
							? value?.join(',')
							: value ?? '-'}
					</Typography>
				</Grid>
			</Grid>
			{!isPreviewPage && label !== 'Business Unit' && <Divider />}
		</div>
	);
	return (
		<div data-testid="details-container">
			{entityData?.map(
				(el: any) => !excludeValues.includes(el.label) && renderDetailRows(el),
			)}
		</div>
	);
};

export default Details;
